import React from 'react';
import { Typography } from '@material-tailwind/react';

interface DateSectionProps {
  date: Date;
}

const DateSection: React.FC<DateSectionProps> = ({ date }) => {
  const formatDate = (date: Date) => {
    return {
      day: date.getDate().toLocaleString(),
      month: date.toLocaleDateString(undefined, { month: 'long' }),
      year: date.toLocaleDateString(undefined, {
        year: 'numeric',
      }),
      weekday: date.toLocaleDateString(undefined, { weekday: 'long' }),
    };
  };

  const { day, month, year, weekday } = formatDate(date);

  return (
    <div className="flex items-center gap-2">
      <Typography 
        variant="h2" 
        className="font-light text-blue-500 text-[36px] leading-none mt-0.5"
        placeholder=""
        onResize={() => {}}
        onResizeCapture={() => {}}
        onPointerEnterCapture={() => {}}
        onPointerLeaveCapture={() => {}}
      >
        {day}
      </Typography>
      <div className="flex flex-col justify-between">
        <Typography 
          variant="h5" 
          className="font-normal text-neutral-grey900 text-[16px] leading-none pb-0.5"
          placeholder=""
          onResize={() => {}}
          onResizeCapture={() => {}}
          onPointerEnterCapture={() => {}}
          onPointerLeaveCapture={() => {}}
        >
          {month.charAt(0).toUpperCase() + month.slice(1)} {year}
        </Typography>
        <Typography 
          variant="h6" 
          className="font-normal text-neutral-grey500 text-[14px] leading-none"
          placeholder=""
          onResize={() => {}}
          onResizeCapture={() => {}}
          onPointerEnterCapture={() => {}}
          onPointerLeaveCapture={() => {}}
        >
          {weekday.charAt(0).toUpperCase() + weekday.slice(1)}
        </Typography>
      </div>
    </div>
  );
};

export default DateSection; 